import React from "react";

// Se um ecrã falhar, mostra o erro em vez de deixar a página vazia (no iPhone ficava tudo preto até fazer refresh).
// A mensagem pode ser fotografada e enviada ao suporte, para se perceber a causa.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erro: null, onde: "" };
  }

  static getDerivedStateFromError(erro) {
    return { erro };
  }

  componentDidCatch(erro, info) {
    this.setState({ onde: (info?.componentStack || "").trim().split("\n").slice(0, 6).join("\n") });
    console.error("[ErrorBoundary]", erro, info);
  }

  render() {
    if (!this.state.erro) return this.props.children;
    const { erro, onde } = this.state;
    return (
      <div style={{ minHeight: "100vh", padding: 24, background: "#0f172a", color: "#e2e8f0", fontFamily: "system-ui, sans-serif" }} data-testid="erro-pagina">
        <h1 style={{ fontSize: 18, marginBottom: 8 }}>Ocorreu um erro nesta página</h1>
        <p style={{ fontSize: 14, marginBottom: 12 }}>Tire uma captura de ecrã desta mensagem e envie-a ao suporte. Depois carregue em «Recarregar».</p>
        <pre style={{ whiteSpace: "pre-wrap", wordBreak: "break-word", fontSize: 12, background: "#1e293b", padding: 12, borderRadius: 8 }}>
          {String(erro?.message || erro)}{onde ? `\n\n${onde}` : ""}
        </pre>
        <button type="button" onClick={() => window.location.reload()} style={{ marginTop: 16, padding: "10px 16px", fontSize: 16, borderRadius: 8, background: "#f97316", color: "#fff", border: 0 }}>
          Recarregar
        </button>
      </div>
    );
  }
}
